export default __webpack_public_path__ + "static/media/support.643d6523.png";